import { Component, OnInit } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { CrudService } from './components/services/crud.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {
    location: any;
    routerSubscription: any;

    constructor(private router: Router, private crudService: CrudService) {
    }

    private _kickInterval: any = null;

    ngOnInit(){
        this.checkAuthKickSwitch();
        this.recallJsFuntions();
        // Polling: ricontrolla ogni 30s anche se l'utente resta fermo su una pagina.
        // Cosi' il kick lanciato dall'admin arriva entro max 30s.
        this._kickInterval = setInterval(() => this.checkAuthKickSwitch(), 30000);
    }

    // Kill-switch a 4 livelli: globale / partner / azienda / corsista.
    // Righe in tbl_settings:
    //   authKickBefore                       -> sloggia TUTTI
    //   authKickBefore_partner_<idPartner>   -> tutti i corsisti di quel partner (centro formazione)
    //   authKickBefore_azienda_<idAzienda>   -> tutti i corsisti di quella azienda (cliente finale)
    //   authKickBefore_corsista_<idCorsista> -> solo quel corsista
    // Il value e' un timestamp in ms (UNIX_TIMESTAMP()*1000). Se loginAt<value → kick.
    // Flag class-level per de-duplicare log e redirect tra chiamate parallele.
    // ngOnInit + NavigationEnd(initial) + setInterval possono innescare
    // checkAuthKickSwitch in rapida successione — se ognuna avesse la sua
    // `kicked` locale, la POST report_kickLogout verrebbe fatta N volte.
    private _kicking = false;

    private checkAuthKickSwitch() {
        if (this._finalized || this._kicking) return;
        const raw = localStorage.getItem('user_id');
        if (!raw) { console.log('[kick-check] no user_id in localStorage — skip'); return; }
        let stored: any;
        try { stored = JSON.parse(raw); } catch (e) { console.log('[kick-check] user_id parse error', e); return; }
        if (!stored) { console.log('[kick-check] user_id empty — skip'); return; }
        const loginAt = parseInt(stored.loginAt, 10) || 0;
        console.log('[kick-check] running — id_corsista=' + stored.id_corsista + ' id_partner=' + stored.id_partner + ' id_azienda=' + stored.id_azienda + ' loginAt=' + loginAt);
        const performKick = (scope: string, scopeId: number, kickBefore: number) => {
            // Guard atomico: JS single-threaded → il primo che entra vince,
            // gli altri (in questa e in altre chiamate parallele) escono subito.
            if (this._kicking || this._finalized) return;
            this._kicking = true;
            try {
                this.crudService.api_report_kickLogout({
                    id_corsista:  stored.id_corsista || 0,
                    id_partner:   stored.id_partner  || 0,
                    id_azienda:   stored.id_azienda  || 0,
                    scope_kicked: scope,
                    scope_id:     scopeId,
                    kick_ts:      kickBefore,
                    login_ts:     loginAt
                }).subscribe({
                    next: () => this.finalizeKick(),
                    error: () => this.finalizeKick()
                });
                // Fallback: se la POST è lenta, sloggia comunque dopo 800ms
                setTimeout(() => this.finalizeKick(), 800);
            } catch (e) {
                this.finalizeKick();
            }
        };
        const kickIfNeeded = (scope: string, scopeId: number) => (res: any) => {
            if (this._kicking || this._finalized) return;
            const kickBefore = parseInt(res, 10);
            console.log('[kick-check] ' + scope + '(' + scopeId + ') → tbl_settings value=' + res + ' → kickBefore=' + kickBefore + ' loginAt=' + loginAt + ' → ' + (loginAt < kickBefore && kickBefore > 0 ? 'KICK' : 'ok'));
            if (!kickBefore || kickBefore <= 0) return;
            if (loginAt < kickBefore) performKick(scope, scopeId, kickBefore);
        };
        this.crudService.api_get_SettingsValue('authKickBefore').subscribe(kickIfNeeded('global', 0));
        if (stored.id_partner) {
            this.crudService.api_get_SettingsValue('authKickBefore_partner_' + stored.id_partner).subscribe(kickIfNeeded('partner', stored.id_partner));
        }
        if (stored.id_azienda) {
            this.crudService.api_get_SettingsValue('authKickBefore_azienda_' + stored.id_azienda).subscribe(kickIfNeeded('azienda', stored.id_azienda));
        }
        if (stored.id_corsista) {
            this.crudService.api_get_SettingsValue('authKickBefore_corsista_' + stored.id_corsista).subscribe(kickIfNeeded('corsista', stored.id_corsista));
        }
    }

    private _finalized = false;
    private finalizeKick() {
        if (this._finalized) return;
        this._finalized = true;
        localStorage.clear();
        window.location.href = '/login';
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
            // Ricontrolla il kill-switch anche ad ogni navigazione SPA:
            // se l'admin kicka mentre l'utente clicca, viene sloggiato al click successivo.
            this.checkAuthKickSwitch();
        });
    }
}